"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormAnchorContext = void 0;
const react_1 = require("react");
exports.FormAnchorContext = react_1.createContext(undefined);
//# sourceMappingURL=form-anchor-context.js.map